import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[vasStopChangePropagation]'
})
export class StopChangePropagationDirective {

    constructor(protected ref: ElementRef) {

    }

    ngOnInit(): void {
        console.log('here', this.ref);
    }

    @HostListener('change', ['$event'])
    onChange(event: any): void {
        event.stopPropagation();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/stop-change-propagation.directive.ts